import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Card, { CardContent, CardMedia } from 'material-ui/Card'
import IconButton from 'material-ui/IconButton'
import Typography from 'material-ui/Typography'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Drawer from 'material-ui/Drawer'
import Button from 'material-ui/Button'
import List from 'material-ui/List'
import Divider from 'material-ui/Divider'

class PopulationCount extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      data: []
    }
  }

  getData() {
    let currentComponent = this

    axios
      .get(
        `https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/0/agehigh/54/agelow/35/oarhigh/10/oarlow/7/herprefage/0/herprefans/0/clrhigh/4/clrlow/1/education/-1/income/-1/cust/${
          this.props.customer_number
        }`
      )
      .then(function(response) {
        if (response.data[0].SearchCount) {
          currentComponent.setState({
            data: response.data[0],
            loaded: true
          })
        } else {
          currentComponent.getData()
        }
      })
  }

  componentDidMount() {
    this.getData()
  }

  render() {
    const { classes, theme, location } = this.props
    const { loaded, data } = this.state

    if (loaded) {
      return (
        <div>
          <Card className={classes.masterCard}>
            <Typography className={classes.text}>
              Active Population Count: {data.SearchCount}
            </Typography>
          </Card>
        </div>
      )
    } else {
      return (
        <div>
          <Card className={classes.masterCard}>
            <Typography className={classes.text}>
              Population Count Loading
            </Typography>
          </Card>
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps)(PopulationCount)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/RapidDisplayView/components/PopulationCount/index.js